// extracted by mini-css-extract-plugin
export default {"table-header-button":"TableHeaderButton_table-header-button__s6j4N"};